import axios from "axios";

// Backend base URL comes from the environment; the API lives under /api.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8016";

export const ASSET_URL = BACKEND_URL; // for /uploads/* logo images

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

// Attach the JWT (house pattern: stored in localStorage) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
